class ServiceAPI {

  static projects = (...services) => authenticated => authenticated.post('services/projects', { services })

  static syncService = service => authenticated => authenticated.post('services/sync', { service })

  static importService = data => authenticated => authenticated.post('services/import', data)

}

export default ServiceAPI
